import "#vendor/sticky-kit/dist/sticky-kit.js";
import "./utilities_namespace.js";

(function ($, CSS) {
  var polyfill = !(CSS && CSS.supports("position", "sticky"));

  window.Sparkle.Utilities.sticky = function (elements, offset) {
    jQuery(elements).each(function (i, element) {
      element = jQuery(element);
      if (polyfill) {
        return element.stick_in_parent({ offset_top: offset.top, sticky_class: "sticky--on" });
      } else {
        return element.css({ position: "sticky" }).css(offset).addClass("sticky--on");
      }
    });
  };

  window.Sparkle.Utilities.unstick = function (elements) {
    jQuery(elements).each(function (i, element) {
      element = jQuery(element);
      if (polyfill) {
        return element.trigger("sticky_kit:detach");
      } else {
        if (element.css("position") != "sticky") {
          return element;
        }
        return element.css({ position: "", top: "", left: "", right: "", bottom: "" }).removeClass("sticky--on");
      }
    });
  };
})(window.jQuery, window.CSS);
